/**
 *@file urlParams
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/8/25 - 16:47
 *@updateTime 2019/8/25 - 16:47
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 @description urlParams url参数。包含1个方法 getUrlParams
 */
export default {

    /**
 * @function
 * @name getUrlParams
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @memberOf   FdGlobal
 * @createTime 2019.08.13
 * @description 获取url中的参数，可以
 * @param {String} [url] 可选参数，一个url地址，可以不传，默认会取window.location.href
 * @returns {object|null} 如果匹配到参数，那么就会返回一个目标对象，否则返回null
 */

    getUrlParams(url) {
        const _url = url || window.location.href;
        const _urlParams = _url.match(/[?&](.+?=[^&=]*)/igm);
        // 默认参数对象
        const _defaultParmas = {};
        return _urlParams ? _urlParams.reduce((a, b) => {
            const value = b.slice(1).split('=');
            a[decodeURI(value[0])] = decodeURI(value[1]);
            return a;
        }, _defaultParmas) : null;
    },

    /**
     * @function
     * @name getUrlQueryString
     * @version 1.0.1
     * @author wuwg  <wuwg@thunisoft.com>
     * @memberOf   FdGlobal
     * @createTime 2019.08.13
     * @description 获取url中的参数，可以
     * @param {Object} [data] url对象
     * @returns {String} 返回一个a=xx&b=xxx字符串，
     */
    getUrlQueryString(data) {
        const _result = [];
        for (const key in data) {
            const value = data[key];
            if (value.constructor === Array) {
                value.forEach((_value) => {
                    _result.push(`${key}=${_value}`);
                });
            } else {
                _result.push(`${key}=${value}`);
            }
        }
        return _result.join('&');
    },
};



// WEBPACK FOOTER //
// ./src/components/tools/extend/getUrlParams.js